import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export default class DarkLightModeService {
  private isDarkMode = false;

  constructor() {
    this.getModeFromLocalStorage();
  }

  private getModeFromLocalStorage(): void {
    const mode = localStorage.getItem('mode');
    this.isDarkMode = mode === 'dark';
  }

  public changeMode(): void {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem('mode', this.isDarkMode ? 'dark' : 'light');
  }

  public get bodyClass(): boolean {
    return this.isDarkMode;
  }
}
